import { Station } from '@app/core/types/stations';
import {
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum,
  usePntSegmentsControllerGetSegmentAdOverlayByDate,
} from '@mi-front/api-v2';
import { parseRangeFromTs } from '@mi-front/core';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import AdoverlayView from './AdoverlayView';
import { filterAdoverlayData, formatAdoverlayData } from './utils';

interface IAdoverlayContainer {
  station: Station;
}

const AdoverlayContainer: React.FunctionComponent<IAdoverlayContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);

  const { data, isLoading } = usePntSegmentsControllerGetSegmentAdOverlayByDate(
    station.slug,
    {
      from: range.from,
      to: range.to,
      withResults: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum.true,
      sortBy: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum.date,
      sortOrder: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.desc,
    },
    {
      query: {
        select: (results) => formatAdoverlayData(filterAdoverlayData(results)),
      },
    },
  );

  return <AdoverlayView data={data} loading={isLoading} station={station} />;
};

export default AdoverlayContainer;
